import { Link } from 'react-router-dom'
import { getHotArticles } from '@/mocks/articles'

export default function HotList() {
  const hotArticles = getHotArticles(6)

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
              热门排行
            </h2>
            <p className="text-foreground-500">根据浏览量和用户评分综合排序</p>
          </div>
          <Link
            to="/category/ranking"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看完整榜单 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {hotArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-44 object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 w-8 h-8 rounded-lg bg-background-950/70 backdrop-blur-sm flex items-center justify-center text-background-50 font-heading font-bold text-sm">
                  {index + 1}
                </div>
                {index < 3 && (
                  <div className="absolute top-3 right-3">
                    <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                      {index === 0 ? 'TOP 1' : index === 1 ? 'TOP 2' : 'TOP 3'}
                    </span>
                  </div>
                )}
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500"></i>
                    {article.rating}
                  </span>
                  <span>{article.views.toLocaleString()} 次浏览</span>
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}